__turbopack_context__.v({
  "animateCallout": "StackSection-module__ZNORhW__animateCallout",
  "animateCard1": "StackSection-module__ZNORhW__animateCard1",
  "animateCard2": "StackSection-module__ZNORhW__animateCard2",
  "animateCard3": "StackSection-module__ZNORhW__animateCard3",
  "animateHeader": "StackSection-module__ZNORhW__animateHeader",
  "animateProof": "StackSection-module__ZNORhW__animateProof",
  "bgBlend": "StackSection-module__ZNORhW__bgBlend",
  "calloutBar": "StackSection-module__ZNORhW__calloutBar",
  "cardBack": "StackSection-module__ZNORhW__cardBack",
  "cardContainer": "StackSection-module__ZNORhW__cardContainer",
  "cardFace": "StackSection-module__ZNORhW__cardFace",
  "cardFront": "StackSection-module__ZNORhW__cardFront",
  "cardInner": "StackSection-module__ZNORhW__cardInner",
  "clickHint": "StackSection-module__ZNORhW__clickHint",
  "fadeInRise": "StackSection-module__ZNORhW__fadeInRise",
  "flipped": "StackSection-module__ZNORhW__flipped",
  "float": "StackSection-module__ZNORhW__float",
  "iconWrapper": "StackSection-module__ZNORhW__iconWrapper",
  "proofText": "StackSection-module__ZNORhW__proofText",
  "pulseGlow": "StackSection-module__ZNORhW__pulseGlow",
  "sectionGlow": "StackSection-module__ZNORhW__sectionGlow",
  "shimmer": "StackSection-module__ZNORhW__shimmer",
});
